import { type PropsWithChildren, type ReactNode } from 'react'

import { IconMagicSolid } from '@procurify/ui'

import { AiActionButtonStyled } from './styles/AiActionButtonStyled'

export interface IAiActionButtonProps {
  icon?: ReactNode
  type?: 'button' | 'submit'
  disabled?: boolean
  ariaLabel?: string
  analyticsId?: string
  onClick?: () => void
}

const DEFAULT_ICON = <IconMagicSolid block size={16} color='white' />

export const AiActionButton = ({
  children,
  icon = DEFAULT_ICON,
  type = 'button',
  disabled,
  ariaLabel,
  analyticsId,
  onClick,
}: PropsWithChildren<IAiActionButtonProps>) => {
  return (
    <AiActionButtonStyled
      type={type}
      disabled={disabled}
      aria-label={ariaLabel}
      analyticsId={analyticsId}
      iconComponent={icon}
      onClick={onClick}
    >
      {children}
    </AiActionButtonStyled>
  )
}
